import { Option } from 'types/common/FormTypes';
import {
  CreateProductOptionAPI,
  CreateProductSubOptionOfProductItem,
  GetSubOption,
  ProductOptionDetail,
  ProductOptionFormType,
  ProductOptionOfProductItemAPI,
  ProductOptionValue,
  ProductOptionValueAPI,
  ProductOptionValueForm,
} from 'types/product/productOptionTypes';
import { PricesByBranch, ProductOptionsSection } from 'types/productTypes';
import { StoreCodes } from 'types/store/StoreTypes';

export function transformProductOptionFormToAPI(
  form: ProductOptionFormType,
  deleteOptions: ProductOptionValueForm[] = []
): CreateProductOptionAPI {
  return {
    name: form.name,
    option_type: parseInt(form.optionType, 10),
    forced_type: parseInt(form.forceType, 10),
    // is_active: parseInt(form.active, 10),
    sort_order: 0,
    // options: form.options.map((opt) => ({
    //   ...(opt.id !== undefined && { id: opt.id }),
    //   name: opt.name,
    //   extra_price: parseFloat(opt.additionalPrice),
    // })),
    options: form.options
      .filter((opt) => opt.id !== undefined)
      .map((opt) => ({
        id: opt.id,
        name: opt.name,
        extra_price: parseFloat(opt.additionalPrice),
      })),
    new_options: form.options
      .filter((opt) => opt.id === undefined)
      .map((opt) => ({
        name: opt.name,
        extra_price: parseFloat(opt.additionalPrice),
      })),
    delete_options: transformSubOptionsToAPI(deleteOptions),
  };
}
export function transformProductOptionAPIToForm(
  data: CreateProductOptionAPI
): ProductOptionFormType {
  return {
    name: data.name,
    optionType: data.option_type.toString(),
    forceType: data.forced_type.toString(),
    // active: data.is_active.toString(),
    options: data.options.map((opt) => ({
      ...(opt.id !== undefined && { id: opt.id }),
      name: opt.name,
      additionalPrice: opt.extra_price.toString(),
    })),
  };
}
export function transformSubOptionsToAPI(
  subOptions: ProductOptionValueForm[]
): ProductOptionValueAPI[] {
  return subOptions.map((opt) => ({
    ...(opt.id !== undefined && { id: opt.id }),
    name: opt.name,
    extra_price: parseFloat(opt.additionalPrice),
  }));
}
export function transformProductOptionAPIToProductForm(
  data: ProductOptionDetail[]
): ProductOptionsSection[] {
  return data.map((item) => ({
    id: item.id,
    name: item.name,
    // selected: item.is_active === 1,
    selected: false,
    options: item.options.map((opt: ProductOptionValue) => ({
      id: opt.id,
      name: opt.name,
      value: opt.extra_price.toString(),
    })),
  }));
}
export function transformProductOptionOfItemFormToAPIFormat(
  data: ProductOptionsSection[]
): ProductOptionOfProductItemAPI[] {
  if (data.length === 0) return [];
  const transformed: ProductOptionOfProductItemAPI[] = [];

  for (const item of data) {
    if (!item.selected) continue;

    const options: CreateProductSubOptionOfProductItem[] = item.options
      .map((option) => {
        const extra_price = parseFloat(option.value);
        if (isNaN(extra_price)) return null;
        return { id: option.id, extra_price };
      })
      .filter(
        (opt): opt is CreateProductSubOptionOfProductItem => opt !== null
      );

    if (options.length > 0) {
      transformed.push({ id: item.id, options });
    }
  }

  return transformed;
}
export function transformProductAPIToProductOptionsSectionForm(
  data: any[]
): ProductOptionsSection[] {
  return data.map((data) => ({
    id: data.id,
    name: data.name,
    selected: true,
    options: data.options.map((opt: GetSubOption) => ({
      id: opt.id,
      name: opt.name,
      value: opt.extra_price.toString(),
    })),
  }));
}

export function updateProductOptions(
  current: ProductOptionsSection[],
  updates: ProductOptionsSection[]
): ProductOptionsSection[] {
  const updateMap = new Map(updates.map((item) => [String(item.id), item]));
  const currentIds = new Set(current.map((item) => String(item.id)));
  const missingUpdates = updates.filter(
    (item) =>
      item.selected &&
      item.options.length > 0 &&
      !currentIds.has(String(item.id))
  );

  return [
    ...current.map((item) => updateMap.get(String(item.id)) ?? item),
    ...missingUpdates,
  ];
}

export function transformPriceBranchToSelectOptions(
  branchCodes: StoreCodes[],
  pricesByBranch: PricesByBranch[]
): Option[] {
  return branchCodes.map((branch) => {
    const priceData = pricesByBranch.find(
      (item) => item.store_id === branch.storeId
    );

    if (priceData) {
      return {
        label: branch.code,
        value: priceData.item_id,
      };
    }
    return { label: branch.code, value: null as unknown as number };
  });
}
